import { SVG, SVGProps } from './svg'

export function IconBriefcase(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M20 21a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h16Zm-10-7.5v.5c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-.5c0-.3-.2-.5-.5-.5h-3c-.3 0-.5.2-.5.5ZM9 7h6V5H9v2ZM4 9h16v10H4V9Z"
      />
    </SVG>
  )
}
